import { createSlice } from '@reduxjs/toolkit';

export const nutritionistSlice = createSlice({
  name: 'wnNutritionist',
  initialState: {
    profile: null,
    schedule: null,
  },
  reducers: {
    setWnNutritionistProfile: (state, action) => {
      state.profile = action.payload;
    },
    setNutritionistSchedule: (state, action) => {
      state.schedule = action.payload;
    },
  },
});

export const { setWnNutritionistProfile, setNutritionistSchedule } =
  nutritionistSlice.actions;

export const WnNutritionistReducer = nutritionistSlice.reducer;
